import Layout from '@/views/index.vue'
import System from './module/system/index.js' //系统
import User from './module/user/index.js'  //用户
import Operate from './module/operate/index.js' //运营
import Equipment from './module/equipment' //车辆
import Statistics from './module/statistics' //统计
import Research from './module/research/index.js' //研发
import AfterSales from './module/afterSales/index' //售后


export const routerList = [
    //layout
    {
        path: '/',
        component: Layout,
        hidden: false,
        meta: {
            title: 'Layout'
        },
        name: 'Layout',
        children: [
            //研发
            ...Research,
            //统计
            ...Statistics,
            //系统
            ...System,
            //用户
            ...User,
            //运营
            ...Operate,
            //车辆
            ...Equipment,
            //售后
            ...AfterSales
        ]

    },
    //登录
    {
        path: '/login',
        name: 'Login',
        component: () => import("@/views/login/index.vue"),
        meta: {
            title: '登录'
        },
        hidden: true
    },
    //忘记密码
    {
        path: '/forgetPassword',
        name: 'forgetPassword',
        component: () => import("@/views/login/forgetPassword.vue"),
        meta: {
            title: '忘记密码'
        },
        hidden: true
    },
    //输入验证码
    {
        path: '/verificationCode',
        name: 'verificationCode',
        component: () => import("@/views/login/verificationCode.vue"),
        meta: {
            title: '输入验证码'
        },
        hidden: true
    },
    //重置密码
    {
        path: '/resetPassword',
        name: 'resetPassword',
        component: () => import("@/views/login/resetPassword.vue"),
        meta: {
            title: '重置密码'
        },
        hidden: true
    },
]


export const routerListA = [
    //layout
    {
        path: '/',
        component: Layout,
        hidden: false,
        meta: {
            title: 'Layout'
        },
        name: 'Layout',
        children: [
            //统计
            // ...Statistics,
        ]

    },
    //登录
    {
        path: '/login',
        name: 'Login',
        component: () => import("@/views/login/index.vue"),
        meta: {
            title: '登录'
        },
        hidden: true
    },
    //忘记密码
    {
        path: '/forgetPassword',
        name: 'forgetPassword',
        component: () => import("@/views/login/forgetPassword.vue"),
        meta: {
            title: '忘记密码'
        },
        hidden: true
    },
    //输入验证码
    {
        path: '/verificationCode',
        name: 'verificationCode',
        component: () => import("@/views/login/verificationCode.vue"),
        meta: {
            title: '输入验证码'
        },
        hidden: true
    },
    //重置密码
    {
        path: '/resetPassword',
        name: 'resetPassword',
        component: () => import("@/views/login/resetPassword.vue"),
        meta: {
            title: '重置密码'
        },
        hidden: true
    },
    
    //测试用
    {
        path: '/404',
        name: '404',
        component: () => import("@/views/404.vue"),
        meta: {
            title: '404'
        },
        hidden: true
    },
    // {
    //     path: '*',
    //     redirect: '/404'
    // }
]
